import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Connector, Journey } from '../../utilities/models/journey.model';


@Injectable({
  providedIn: 'root',
})
export class JourneyService {
  private readonly http = inject(HttpClient);

  public journeyList!: Journey[];

  private readonly onChangeJourney = new BehaviorSubject<Journey | null>(null);
  get journey() {
    return this.onChangeJourney.value;
  }
  get journey$(): Observable<Journey> {
    return this.onChangeJourney.asObservable().pipe(filter((journey) => journey != null));
  }

  setSessionJourney(journeyId: number) {
    const journey = this.journeyList.find((j) => j.id === journeyId) || this.journeyList[0];
    this.onChangeJourney.next(journey);
  }

  getJourneysList() {
    return this.http.get<Journey[]>(`${environment.API.orchestrator_configurator}/journey`).pipe(
      tap((journeyList: Journey[]) => {
        this.journeyList = journeyList;
        const journeyId = this.journey?.id || this.journeyList[0].id;
        this.setSessionJourney(journeyId);
      })
    );
  }

  createJourney(data: any): Observable<Journey> {
    return this.http
      .post<Journey>(`${environment.API.orchestrator_configurator}/journey`, data)
      .pipe(switchMap((journey) => this.getJourneysList().pipe(map(() => journey))));
  }

  editJourney(data: any): Observable<boolean> {
    return this.http.put(`${environment.API.orchestrator_configurator}/journey`, data).pipe(
      switchMap(() => this.getJourneysList()),
      map(() => true)
    );
  }

  deleteJourney(journeyId: number): Observable<boolean> {
    const httpOptions = {
      params: new HttpParams().set('journeyId', journeyId.toString()),
    };
    return this.http.delete(`${environment.API.orchestrator_configurator}/journey`, httpOptions).pipe(
      switchMap(() => this.getJourneysList()),
      map(() => true)
    );
  }

  getJourneyConnector(code: string): Connector | undefined {
    return this.journey?.connectors.find((connector) => connector.code === code);
  }

  getJourneyApiKey(): string | undefined {
    return this.journey?.apiKey;
  }

  isProductConfigured(
    // configuration: Array<Partial<Journey>> | Partial<Journey> | Array<keyof typeof AgentType> | keyof typeof AgentType,
    configuration: any,
    journeyId?: number | null
  ): boolean {
    const journey: any = journeyId ? this.journeyList.find((item) => item.id === journeyId) : this.journey;

    if (!Array.isArray(configuration)) configuration = [<Partial<Journey>>configuration];
    if (typeof configuration[0] === 'string') configuration = (configuration as Array<any>).map((item) => ({ type: item }));

    return configuration.some((restriction: any) =>
      Object.keys(restriction)
        .filter((key) => typeof restriction[key] === 'boolean' || typeof restriction[key] === 'string')
        .every((key) => restriction[key] === journey[key])
    );
  }
}
